
/**
 * @profile
 */
export const FIRST_NAME_REQUIRED = "First name is required";
export const LAST_NAME_REQUIRED = "Last name is required";

export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const PASSWORD_MIN_CHAR = 8;
export const PASSWORD_REQUIRED = "Password is required";
export const PASSWORD_STRENGTH = `The password must be at least ${PASSWORD_MIN_CHAR} characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.`;
export const PASSWORD_MUST_MATCH = "Confirm Password must match with the password";
export const MIN_CHAR_LENGTH = `Password must be at least ${PASSWORD_MIN_CHAR} characters long.`;
export const NEW_PASSWORD_SHOULD_DIFF = "New password should not match the current password";
export const CONFIRM_PASSWORD_REQUIRED = "Confirm password is required";

/**
 * @Tracker
 */
export const TRACKER_REQUIRED = "Insight name is required.";
export const PHRASE_REQUIRED = "Please enter a phrase.";

/**
 * @CreateCompany
 */
export const COMPANY_NAME_REQUIRED = "Company name is required.";
export const COMPANY_CONTACT_REQUIRED = "Contact name is required.";
export const COMPANY_EMAIL_REQUIRED = "Email address is required.";
export const COMPANY_EMAIL_INVALID = "Please enter a valid email address.";


/**
 * @CreateUser
 */
export const USER_NAME_REQUIRED = "Please choose a company.";
export const USER_EMAIL_REQUIRED = "Email address is required.";
export const USER_EMAIL_INVALID = "Please enter a valid email address.";

/**
 * @CreateCampaign
 */
export const CAMPAIGN_COMPANY_NAME_REQUIRED = "Please enter a company name.";
export const CAMPAIGN_NAME_REQUIRED = "Campaign name is required.";
export const CAMPAIGN_NAME_MIN_CHAR = 2;
export const CAMPAIGN_NAME_MAX_CHAR = 100;
export const CAMPAIGN_NAME_CHAR_MESSAGE = `Campaign name must be between ${CAMPAIGN_NAME_MIN_CHAR} and ${CAMPAIGN_NAME_MAX_CHAR} characters long.`;
export const CAMPAIGN_TYPE_REQUIRED = "Campaign type is required.";
export const CAMPAIGN_DIRECTION_REQUIRED = "Call direction is required.";
export const CAMPAIGN_START_DATE_REQUIRED = "Start date is required.";
export const CAMPAIGN_START_DATE_INVALID = "Start date is invalid.";
export const CAMPAIGN_END_DATE_REQUIRED = "End date is required.";
export const CAMPAIGN_END_DATE_INVALID = "End date is invalid.";
export const CAMPAIGN_END_DATE_MIN = "End Date should not be less than start date.";
export const CAMPAIGN_TRACKERS_REQUIRED = "Please select at least one item.";
export const CAMPAIGN_AGENT_NAME_REQUIRED = "Please enter agent name.";